import CyclesTable from '../../components/cycles_table'

const Cycles = ({ airlineID }) => {
  return <CyclesTable queryKey={`cycles?airlineID=${airlineID}`} />
}

export default Cycles
